import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import Login from './src/screens/login';
import Home from './src/screens/home';


const Stack = createNativeStackNavigator();


export default function App() {
  return (
    <NavigationContainer linking>
      <Stack.Navigator initialRouteName="Login"
        // hide back button
        screenOptions={{
          headerShown: false
        }}
      >
        <Stack.Screen name="Login" component={Login} />
        <Stack.Screen name="Home" component={Home} />
      </Stack.Navigator>
    </NavigationContainer>
  );
}
